import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/services/app/app.service";

@Component({
  selector: "app-services",
  templateUrl: "./services.component.html",
  styleUrls: ["./services.component.css"],
})
export class ServicesComponent implements OnInit {
  isCollapsed: boolean = false;
  lang: string;
  finalJson: any;
  termsCondition: any[] = [
    {
      "id": "q1",
      "questionAr": "الحصول على تغطية تأمينية مناسبة تلبي احتياجك",
      "questionEn": "Obtaining suitable insurance coverage that meets your needs",
      "answerAr":
        "نقدم لعملائنا حلول تأمينية مخصصة صممت بناءً على تحليل دقيق لاحتياجاتهم الفردية أو التجارية من خلال منصتنا الرقمية المتقدمة وفريق خبرائنا.",
      "answerEn":
        "We offer our clients customized insurance solutions designed based on a precise analysis of their individual or business needs through our advanced digital platform and team of experts."
    },
    {
      "id": "q2",
      "questionAr": "تقديم المساندة في حالة نشوء إشكالية اثناء عملية شراء وثيقة التأمين",
      "questionEn": "Providing support in case of issues during the process of purchasing an insurance policy",
      "answerAr":
        "نفهم أن عملية شراء وثيقة التأمين قد تواجه بعض التحديات التقنية أو الفنية. لذلك، نوفر دعمًا فوريًّا ومتخصصًا لمساعدة العملاء في تجاوز أي عقبات قد تواجههم أثناء عملية الشراء، مما يضمن تجربة سلسة وخالية من الإجهاد.",
      "answerEn":
        "We understand that purchasing an insurance policy may encounter some technical or practical challenges. Therefore, we provide immediate and specialized support to help customers overcome any obstacles they may face during the purchase process, ensuring a smooth and stress-free experience."
    },
    {
      "id": "q3",
      "questionAr": "تقديم إيضاحات ما بعد شراء الوثيقة تتعلق بشروط واحكام وثيقة التأمين او عند نشوء حادث يستدعي تقديم مطالبة",
      "questionEn": "Offering clarifications post-purchase of the policy related to the terms and conditions of the insurance policy or when an incident occurs that requires filing a claim",
      "answerAr":
        "بعد شراء الوثيقة، نستمر في تقديم دعم استشاري متكامل لضمان فهم العميل لجميع شروط وأحكام وثيقته التأمينية. في حالة وقوع حادث، نقدم إرشادات مفصلة حول كيفية تقديم المطالبة بفعالية لضمان تعويض سريع وعادل.",
      "answerEn":
        "After purchasing the policy, we continue to provide comprehensive advisory support to ensure the customer understands all the terms and conditions of their insurance policy. In the event of an accident, we provide detailed guidance on how to effectively apply a claim to ensure quick and fair compensation."
    }
  ];
  constructor(private appService: AppService) {}

  ngOnInit(): void {
    this.appService.getAppLang().subscribe((language) => {
      this.lang = language;
    });
  }
}
